import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=0383c08a&scoped=true&"
import script from "./FilterItem.vue?vue&type=script&lang=js&"
export * from "./FilterItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem.vue?vue&type=style&index=0&id=0383c08a&lang=scss&scoped=true&"
import style1 from "./FilterItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383c08a",
  null
  
)

export default component.exports